import React from "react";
import { connect } from "react-redux";
import IAppState from "../../../redux/types/IAppState";
import IShortCutKeys from "../../../redux/types/IShortCutKeys";

export const pageMatchMap: Record<string, string> = {
  works: "WorksPage",
  products: "ProductsPage",
  agreements: "AgreementsPage",
  artists: "ArtistsPage",
  ips: "IPsPage",
  licenses: "LicensesPage",
  claims: "ClaimsPage",
  usages: "FindUsagePage",
  pools: "UsagePoolsPage",
  distributions: "DistributionsPage",
  adjustments: "AdjustmentsPage",
  paymentRuns: "PaymentRunsPage", 
  UsageMaintenancePage: "UsageMaintenancePage"
};

export interface ISearchViewKeyEventListenerComponentProps {
    setStateInitial: () => void;
    onSave: () => void;
    paneIndex?: number;
    componentInstance?: string;
    isSearching?: boolean;
    ignorePageMatchForModal?: boolean;
};
export interface IStateProps {shortCutKeys: IShortCutKeys[], tabs: any[], activeTab: number}

type ICombinedToolbarConnectProps = ISearchViewKeyEventListenerComponentProps & IStateProps;

const SearchViewKeyEventListener: React.FC<ICombinedToolbarConnectProps> = ({
    setStateInitial,
    ignorePageMatchForModal = false,
    shortCutKeys,
    onSave: onSearch,
    tabs,
    activeTab,
    componentInstance,
    isSearching,
}) => {
    const [keysPressed, setKeysPressed] = React.useState([]);
    const areCorrectKeysPressed = (actionCode, keysPressed) => {
        const shortCutKeysCommaSeparatedString = shortCutKeys && shortCutKeys.find(key => key.actionCode === actionCode)?.key
        const shortCutKeysArray = shortCutKeysCommaSeparatedString ? shortCutKeysCommaSeparatedString.split(','): [];
        let filteredRequiredPressedKeys = shortCutKeysArray && shortCutKeysArray.filter(keyString => keysPressed[keyString]);
        return filteredRequiredPressedKeys?.length === shortCutKeysArray?.length;
    }
    const [activeTabComponent, setActiveTabComponent] = React.useState(tabs && tabs[activeTab] && tabs[activeTab].component)

    React.useEffect(() => {
        setActiveTabComponent(tabs && tabs[activeTab] && tabs[activeTab].component)
    }, [tabs, activeTab])


    const emptySearchFields  = (e, pressedKeys) => {     

        if (areCorrectKeysPressed("EMPTY_FIELD_ON_SEARCH_GRID", pressedKeys)){
            setStateInitial()
            setKeysPressed(([]))
        }
    }

    const triggerSearch = (e, pressedKeys) => {
    if (areCorrectKeysPressed("SEARCH_CURRENT_GRID_ROW", pressedKeys)) {
        onSearch && pageMatchMap[componentInstance] === activeTabComponent && !isSearching && onSearch();
        setKeysPressed([]);
    }};

    const setKeyState = (event, state) => {
        setKeysPressed((prevState) => {
            const newState = {...prevState};
            newState[event.key] = state;
            emptySearchFields(event, newState);
            triggerSearch(event, newState);
            return newState});
    }

    const setTheKeyPressFalse = (event) => {
        setKeysPressed((prevState) => {
            const newState = {...prevState};
            newState[event.key] = false;
            return newState});
    }
    const handleBlur = () => {
        setKeysPressed((prevState) => ([]))
    };


    React.useEffect(() => {

    const isActive = ignorePageMatchForModal || pageMatchMap[componentInstance] === activeTabComponent;

        const onKeyDown = (event) => {
            if (!isActive) return;
            if (event.target && (event.target.tagName === 'TEXTAREA' || event.target.isContentEditable)) return;
            setKeyState(event, true)
        }
        const onKeyUp = (event) => {
            if (event.target && (event.target.tagName === 'TEXTAREA' || event.target.isContentEditable)) return;
            setTheKeyPressFalse(event)
        }

        window.addEventListener('keydown', onKeyDown)
        window.addEventListener('blur', handleBlur);

        window.addEventListener('keyup', onKeyUp);

        return () => {

            window.removeEventListener('keydown', onKeyDown)
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('keyup', onKeyUp);
        }


    }, [activeTabComponent, componentInstance]);

    return <></>;

}

export default connect((state: IAppState, props: ISearchViewKeyEventListenerComponentProps) => ({
    shortCutKeys: state.repertoire.shortCutKeys,
    tabs: state.repertoire.panes[state.repertoire.activePane || 0].tabs,
    activeTab: state.repertoire.panes[state.repertoire.activePane || 0].activeTab,
    isSearching: state.repertoire.isSearching,
}), null)(SearchViewKeyEventListener);
